import {fetch as fetchPolyfill} from "whatwg-fetch";
import {initI18} from "./src/logic/i18n";
window.fetch = fetchPolyfill;
initI18("en");